'use client';

import { TERM_CATEGORY } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { ROUTES } from '@/constants';
import { useGlobalStore } from '@/stores/GlobalStore';

interface PolicyInfoProps {
  onOpenTerms?: () => void;
}

export const PolicyInfo = ({ onOpenTerms }: PolicyInfoProps) => {
  const setTermsDrawerType = useGlobalStore(
    (state) => state.setTermsDrawerType,
  );

  const handleOpenTerms = (termCategory: TERM_CATEGORY) => {
    onOpenTerms?.();
    setTermsDrawerType(termCategory);
  };

  return (
    <div className="flex flex-col">
      <p className="pb-8 font-700 text-Gray-600 typo-body4">정책 및 법률</p>
      <ul className="flex flex-col gap-4 font-400 text-Gray-600 typo-body4">
        <li>
          <CustomLink
            href={ROUTES.MY_NOTICE}
            aria-label="공지사항 페이지로 이동"
          >
            공지사항
          </CustomLink>
        </li>
        <li>
          <button
            type="button"
            onClick={() => handleOpenTerms(TERM_CATEGORY.SERVICE_TERMS)}
          >
            이용약관
          </button>
        </li>
        <li>
          <button
            className="font-700 text-B-500 underline"
            type="button"
            onClick={() => handleOpenTerms(TERM_CATEGORY.PRIVACY_POLICY)}
          >
            개인정보처리방침
          </button>
        </li>
        <li>
          <button
            type="button"
            onClick={() => handleOpenTerms(TERM_CATEGORY.MARKETING_TERMS)}
          >
            마케팅이용동의
          </button>
        </li>
        <li>
          <button
            type="button"
            onClick={() =>
              handleOpenTerms(TERM_CATEGORY.LOCATION_POLICY_SELECT)
            }
          >
            위치기반서비스 이용약관
          </button>
        </li>
      </ul>
    </div>
  );
};
